module.exports = __webpack_public_path__ + "img/xlsx.a9422184.svg";